(function(){
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function money(v){var n=parseFloat(v);if(isNaN(n))return '';try{return new Intl.NumberFormat('en-PK',{style:'currency',currency:(window.ZB&&ZB.currency)||'PKR',maximumFractionDigits:0}).format(n)}catch(e){return 'Rs '+Math.round(n)}}
function img(r){var u=(r.featured_image&&r.featured_image.url)||(typeof r.image==='string'?r.image:'');if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width=96'}
function setup(form){
  var input=form.querySelector('[data-zb-input]'),box=form.querySelector('[data-zb-results]'),timer,ctl,idx=-1;
  function hide(){box.hidden=true;box.innerHTML='';idx=-1}
  function group(title,items,withPrice){
    if(!items||!items.length)return '';
    return '<div class="zb-sh">'+title+'</div>'+items.map(function(r){
      var im=img(r);
      return '<a class="zb-si" href="'+esc(r.url)+'">'+(im?'<img src="'+esc(im)+'" alt="" loading="lazy">':'')+'<span>'+esc(r.title)+'</span>'+(withPrice&&r.price?'<b>'+money(r.price)+'</b>':'')+'</a>';
    }).join('');
  }
  function render(q,res){
    var r=(res&&res.resources&&res.resources.results)||{};
    var html=group('Products',r.products,true)+group('Collections',r.collections)+group('Pages',r.pages)+group('Articles',r.articles);
    var all=root+'search?'+new URLSearchParams(new FormData(form)).toString();
    box.innerHTML=html?html+'<a class="zb-sall" href="'+esc(all)+'">See all results for “'+esc(q)+'” →</a>':'<div class="zb-sno">No quick matches for “'+esc(q)+'”. Press Enter to search the whole store.</div>';
    box.hidden=false;idx=-1;
  }
  function query(){
    var q=input.value.trim();
    if(q.length<2){hide();return}
    if(ctl)ctl.abort();
    ctl=window.AbortController?new AbortController():null;
    var url=root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,page,article&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url,ctl?{signal:ctl.signal}:{}).then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(d){if(input.value.trim()===q)render(q,d)}).catch(function(){})
  }
  input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(query,250)});
  input.addEventListener('focus',function(){if(input.value.trim().length>=2&&box.innerHTML)box.hidden=false});
  input.addEventListener('keydown',function(e){
    var items=[].slice.call(box.querySelectorAll('.zb-si'));
    if(e.key==='Escape'){hide();return}
    if(!items.length||box.hidden)return;
    if(e.key==='ArrowDown'||e.key==='ArrowUp'){
      e.preventDefault();
      if(items[idx])items[idx].classList.remove('on');
      idx=e.key==='ArrowDown'?(idx+1)%items.length:(idx-1+items.length)%items.length;
      items[idx].classList.add('on');items[idx].scrollIntoView({block:'nearest'});
    }else if(e.key==='Enter'&&items[idx]){e.preventDefault();window.location.href=items[idx].href}
  });
  form.addEventListener('submit',function(e){if(!input.value.trim()){e.preventDefault();input.focus()}else hide()});
}
[].slice.call(document.querySelectorAll('[data-zb-search]')).forEach(setup);
var tg=document.querySelector('[data-zb-toggle]'),panel=document.querySelector('[data-zb-panel]');
if(tg&&panel){
  tg.addEventListener('click',function(){
    var open=panel.hidden;panel.hidden=!open;tg.setAttribute('aria-expanded',open?'true':'false');
    if(open){var i=panel.querySelector('[data-zb-input]');if(i)setTimeout(function(){i.focus()},30)}
  });
}
document.addEventListener('click',function(e){
  [].slice.call(document.querySelectorAll('[data-zb-search]')).forEach(function(f){
    if(!f.contains(e.target)){var b=f.querySelector('[data-zb-results]');if(b)b.hidden=true}
  });
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panel&&!panel.hidden&&window.innerWidth<=860){panel.hidden=true;if(tg)tg.setAttribute('aria-expanded','false')}});
})();
